import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './content-display-with-no-icons-and-image.component.scss';
var ContentDisplayWithNoIconsAndImage = /** @class */ (function (_super) {
    tslib_1.__extends(ContentDisplayWithNoIconsAndImage, _super);
    function ContentDisplayWithNoIconsAndImage(element) {
        return _super.call(this, element) || this;
    }
    ContentDisplayWithNoIconsAndImage.prototype.init = function () {
    };
    ContentDisplayWithNoIconsAndImage.prototype.bindEvents = function () {
    };
    return ContentDisplayWithNoIconsAndImage;
}(Base));
export { ContentDisplayWithNoIconsAndImage };



//////////////////
// WEBPACK FOOTER
// ./components/content-display-with-no-icons-and-image/content-display-with-no-icons-and-image.component.ts
// module id = 229
// module chunks = 0